import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';
import {DatetimeModule} from '../../components/datetime/datetime.module';
import {ClassifiedsComponent} from './classifieds.component';
import {ClassifiedsFilterComponent} from '../../components/classifieds-filter/classifieds-filter.component';
import {ClassifiedsService} from '../../services/classifieds.service';
import {ClassifiedsListComponent} from './classifieds-list/classifieds-list.component';
import {ClassifiedsModalComponent} from './classifieds-modal/classifieds-modal.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        ClassifiedsComponent,
        ClassifiedsFilterComponent,
        ClassifiedsListComponent,
        ClassifiedsModalComponent
    ],
    providers: [
        ClassifiedsService
    ]
})
export class ClassifiedsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/classifieds/classifieds.module.ts